import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import autoBind from 'react-autobind';
import { browserHistory } from 'react-router';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import { cyan900, cyan500 } from 'material-ui/styles/colors';
import DialogModal from '../home/DialogModal';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem'; // eslint-disable-line no-unused-vars

const propTypes = {
  admin: PropTypes.object,
  onSave: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onView: PropTypes.func.isRequired,
};

class EditAdmin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dialogTitle: ' ',
      dialogMessage: ' ',
      dialogActionTitle: ' ',
      required: {
        email: null,
        password: null,
        role: null,
      },
      admin: {
        id: 0,
        name: null,
        email: null,
        signupDate: null,
        role: null,
      },
      open: false,
      edited: false,
      viewRedirect: false,
    };
    autoBind(this);
  }
  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }
  componentWillReceiveProps(nextProps) {
    const admin = nextProps.admin;
    if (nextProps.admin) {
      this.setState({ admin });
    }
    this.setRequiredParams();
  }
  setRequiredParams() {
    const required = this.state.required;
    const admin = this.state.admin;
    Object.keys(this.state.required).forEach((paramName) => {
      const param = admin[paramName];
      required[paramName] = (param == null || param.length === 0 || param === 0) ? 'This field is required' : null;
    });
    this.setState({ required });
  }
  handleSelectChange(event, index, value, target) {
    const admin = this.state.admin;
    admin[target] = value;
    this.setState(admin);
    this.setRequiredParams();
  }
  handleChange(e) {
    const admin = this.state.admin;
    admin[e.target.name] = e.target.value;
    this.setState({
      admin,
      edited: true,
    });
    this.setRequiredParams();
  }
  handleDeleteOpen() {
    const nextState = this.state;
    nextState.dialogTitle = 'Delete Admin';
    nextState.dialogMessage = 'Do you really want to delete this admin?';
    nextState.dialogActionTitle = 'Delete';
    nextState.open = true;
    nextState.delete = true;
    this.setState({ nextState });
  }
  handleDatePickerChange(e, date) {
    this.setState(this.state.admin.signupDate = date);
  }
  navigateToView() {
    if (this.state.edited === true) {
      const nextState = this.state;
      nextState.viewRedirect = true;
      this.setState(nextState);
      this.handleOpen();
    } else {
      browserHistory.push(`/admins/view/${this.state.admin.id}`);
    }
  }
  handleClose() {
    this.setState({
      open: false,
      edited: false,
      viewRedirect: false,
    });
    if (this.state.viewRedirect) {
      browserHistory.push(`/admins/view/${this.state.admin.id}`);
    }
  }
  handleOpen() {
    const nextState = this.state;
    nextState.dialogTitle = 'Save Admin Changes';
    nextState.dialogMessage = 'Do you really want to save the changes in this admin?';
    nextState.dialogActionTitle = 'Save';
    nextState.open = true;
    this.setState({ nextState });
  }
  saveChanges() {
    this.setState({
      open: false,
      edited: false,
      viewRedirect: false,
    });
    switch (true) {
      case (this.state.delete):
        this.props.onDelete(this.props.admin.id);
        break;
      case (this.state.edited && this.state.viewRedirect):
        this.props.onView(this.state.admin);
        break;
      default:
        this.props.onSave(this.state.admin);
        break;
    }
  }
  handleCancel() {
    browserHistory.push('/admins?page=1');
  }
  render() {
    const styles = {
      floatingLabelStyle: {
        color: cyan900,
      },
      inputStyle: {
        marginRight: '2%',
        width: '250px',
      },
    };
    return (
      <div>
        <DialogModal
          dialogOpen={this.state.open}
          dialogHandleClose={this.handleClose}
          dialogHandleSubmit={() => this.saveChanges()}
          dialogTitle={this.state.dialogTitle}
          dialogMessage={this.state.dialogMessage}
          dialogActionTitle={this.state.dialogActionTitle}
        />
        <div className="float-right">
          <RaisedButton
            label="Cancel"
            style={{ marginRight: '10px' }}
            primary
            onClick={this.handleCancel}
          />
          <RaisedButton
            style={{ marginRight: '10px' }}
            label="View"
            primary
            onClick={this.navigateToView}
          />
          <RaisedButton
            style={{ marginRight: '10px' }}
            label="Delete"
            primary
            onClick={this.handleDeleteOpen}
          />
          <RaisedButton
            label="Save"
            primary
            onClick={this.handleOpen}
          />
        </div>
        <br />
        <TextField
          floatingLabelText="ID"
          floatingLabelStyle={styles.floatingLabelStyle}
          inputStyle={styles.inputStyle}
          value={this.state.admin.id}
          disabled
        />
        <br />
        <TextField
          floatingLabelText="Name"
          floatingLabelStyle={styles.floatingLabelStyle}
          value={this.state.admin.name}
          name="name"
          onChange={this.handleChange}
          style={styles.inputStyle}
        />
        <TextField
          floatingLabelText="Email"
          floatingLabelStyle={styles.floatingLabelStyle}
          value={this.state.admin.email}
          name="email"
          onChange={this.handleChange}
          style={styles.inputStyle}
          errorText={this.state.required.email}
          errorStyle={{ color: cyan500 }}
        />
        <TextField
          floatingLabelText="Sign Up Date"
          floatingLabelStyle={styles.floatingLabelStyle}
          style={styles.inputStyle}
          value={this.state.admin.signupDate}
          disabled
        />
        <SelectField
          value={this.state.admin.role}
          onChange={(event, index, value) => this.handleSelectChange(event, index, value, 'role')}
          floatingLabelText="Role"
          style={{ float: 'left', verticalAlign: 'bottom', marginRight: '2%', width: '250px' }}
          name="role"
          floatingLabelStyle={styles.floatingLabelStyle}
          errorStyle={{ color: cyan500 }}
          errorText={this.state.required.role}
        >
          <MenuItem value={0} primaryText="Superadmin" />
          <MenuItem value={1} primaryText="Admin" />
          <MenuItem value={2} primaryText="Operator" />
          <MenuItem value={3} primaryText="Fulfillment" />
          <MenuItem value={4} primaryText="Read Only" />
        </SelectField>
        <br />
        <TextField
          floatingLabelText="Reset Password"
          floatingLabelStyle={styles.floatingLabelStyle}
          name="password"
          onChange={this.handleChange}
          style={styles.inputStyle}
          value={this.state.admin.password}
          type="password"
        />
      </div>
    );
  }
}

EditAdmin.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

EditAdmin.propTypes = propTypes;

function mapStateToProps(state) {
  return {
    admin: state.admins.admin,
  };
}

export default connect(mapStateToProps)(EditAdmin);



// WEBPACK FOOTER //
// ./src/components/admins/EditAdmin.js